import questionsReducers from '../question/question.reducer';

function saveQuiz(sess, quiz) {
    const {Quiz} = sess;
    const questionsModel = quiz.questions.map(question => {
        return questionsReducers.saveQuestion(sess, question);
    });
    return Quiz.create({
        ...quiz,
        questions: questionsModel,
    });
}

function removeQuiz(sess, id) {

}

function saveOverview(sess, overview, courseId) {
    const { QuizOverview } = sess;
    QuizOverview.create({
        title: overview.title,
        description: overview.description,
        status: overview.status,
        questionCount: overview.totalQuestionCount,
        correctAnswer: overview.correctAnswerCount,
        unit: overview.unit,
        course: courseId
    });
}

function clearOverviews(sess) {
    const { QuizOverview } = sess;
    QuizOverview.all().delete();
}

function setQuizProgress(sess, id, grade, correctCount, wrongCount, notAnsweredCount) {
    const {QuizUnit} = sess;
    if (!QuizUnit.idExists(id)) {
        throw new Error(`can not find quiz unit with id '${id}'`);
    }
    if (!QuizUnit.withId(id).quiz) {
        throw new Error(`can not find quiz from QuizUnit with id '${id}'`);
    }
    QuizUnit.withId(id).quiz.update({
        grade: grade,
        correctCount: correctCount,
        wrongCount: wrongCount,
        notAnsweredCount: notAnsweredCount,
        isAnswered: true
    });
}

export default {
    saveQuiz,
    removeQuiz,
    saveOverview,
    setQuizProgress,
    clearOverviews,
}